/* MZYEN — complément d'accessibilité des overlays existants (panier, recherche).
   Ne remplace ni ne monkey-patch aucun contrôleur du thème : il observe l'état
   des composants natifs et ajoute Échap, focus initial et restitution du focus. */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) return false;
    var style = window.getComputedStyle(el);
    return style.visibility !== 'hidden' && style.display !== 'none';
  }

  function focusables(root) {
    if (!root) return [];
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), visible);
  }

  onReady(function () {
    /* Panier latéral : Échap ferme, focus initial et restitution. */
    var drawer = document.querySelector('m-cart-drawer');
    if (drawer) {
      var lastTrigger = null;
      var wasActive = drawer.classList.contains('m-cart-drawer--active');

      document.addEventListener('click', function (e) {
        var trigger = e.target.closest && e.target.closest('.m-cart-icon-bubble');
        if (trigger) lastTrigger = trigger;
      });

      function closeDrawer() {
        var btn = drawer.querySelector('[data-mzy-close]') || drawer.querySelector('.m-cart-drawer__close');
        if (btn) btn.click();
      }

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (!drawer.classList.contains('m-cart-drawer--active')) return;
        closeDrawer();
      });

      new MutationObserver(function () {
        var active = drawer.classList.contains('m-cart-drawer--active');
        if (active && !wasActive) {
          var items = focusables(drawer);
          if (items.length) items[0].focus({ preventScroll: true });
        } else if (!active && wasActive) {
          if (visible(lastTrigger)) lastTrigger.focus({ preventScroll: true });
        }
        wasActive = active;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    /* Recherche : Échap ferme depuis n'importe où dans le popup. */
    var search = document.querySelector('m-search-popup');
    if (search) {
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !search.hasAttribute('open')) return;
        search.closeSearchPopup();
        MinimogEvents.emit(MinimogTheme.pubSubEvents.closeSearchPopup);
      });
    }
  });
})();
